<div class="loading-section">
    <div class="clock-loader"></div>
    <div class="loading-text">Loading...</div>
</div>